import { modalClasses, Theme } from '@mui/material';

export default function Modal(theme: Theme) {
  return {
    MuiModal: {
      styleOverrides: {
        root: {
          ...(theme.palette.mode === 'dark'
            ? {
                [`.${[modalClasses.backdrop]}`]: {
                  backgroundColor: 'rgba(121, 149, 182, 0.15)',
                },
              }
            : {}),
        },
      },
    },
  };
}
